import styled from 'styled-components';

const messages = [
  'Complimentary shipping on orders over $250',
  'New Season — Autumn / Winter Collection',
  'Newsletter subscribers get first look at new drops',
  'Sign in for 10% off your first order',
];

const Bar = styled.div`
  /* Height / rhythm aligned with maison PromoBar marquee segments */
  display: flex;
  align-items: stretch;
  min-height: clamp(36px, 1.1vw + 28px, 46px);
  background: crimson;
  color: ${({ theme }) => theme.colors.cream};
  font-size: clamp(10px, 0.12vw + 9px, 13px);
  font-family: ${({ theme }) => theme.fonts.sans};
  letter-spacing: 0.12em;
  text-transform: uppercase;
  font-weight: 500;
  overflow: hidden;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`;

const MarqueeWrap = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex: 1;
`;

const Item = styled.span`
  display: flex;
  align-items: center;
  gap: 4rem;
  white-space: nowrap;
  padding-block: clamp(10px, 0.9vw + 6px, 14px);
  padding-inline: clamp(20px, 4vw, 36px);
`;

const Diamond = styled.span`
  color: rgba(245, 242, 235, 0.85);
`;

export function AnnouncementBar() {
  const looped = [...messages, ...messages, ...messages, ...messages];
  return (
    <Bar>
      <MarqueeWrap>
        <div className="marquee-track">
          {looped.map((m, i) => (
            <Item key={`${m}-${i}`}>
              <Diamond>◆</Diamond>
              <span>{m}</span>
            </Item>
          ))}
        </div>
      </MarqueeWrap>
    </Bar>
  );
}
